module.exports = __webpack_public_path__ + "be42650932886b81f0358c39143cb389.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/backgrounds/2.jpg
// module id = 389
// module chunks = 0